import { render, staticRenderFns } from "./VozGuidelineFamilySection.vue?vue&type=template&id=24e7a0b8"
import script from "./VozGuidelineFamilySection.vue?vue&type=script&lang=ts"
export * from "./VozGuidelineFamilySection.vue?vue&type=script&lang=ts"
import style0 from "./VozGuidelineFamilySection.vue?vue&type=style&index=0&id=24e7a0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports